import React from 'react';
import { remCalc } from 'utils';
var LIST_ICON_STYLES = 'flex justify-center items-center w-6 p-0 m-0 text-primary content-center';
var LIST_ICON_INLINE_STYLES = { flex: "0 0 " + remCalc(24) };
export var ListIcon = function (_a) {
    var children = _a.children;
    return (React.createElement("p", { className: LIST_ICON_STYLES, style: LIST_ICON_INLINE_STYLES }, children));
};
ListIcon.displayName = 'Content.ListIcon';
